/*
 * Working hours calls go straight to WebAPI (see Util/webAPICall) so that
 * structured errors come back intact.
 * See PLAN.md "#3883 API contract" for the routes and the pattern shape:
 *   { WorkingHoursID, PartyID, EffectiveFrom, EffectiveTo|null, CreatedDate,
 *     Days: [{ DayOfWeek, StartTime, FinishTime }] }
 * Every helper resolves to { data, error } rather than rejecting.
 */
import webAPICall from '../Util/webAPICall';

const FEATURE = 'working hours';

/** For WebAPIProblem: while working hours are display only, a failure affects nothing else */
export const WORKING_HOURS_IMPACT = 'Working hours are only shown for information. The rest of '
    + 'Chronos, including bookings, availability and tasks, works as normal.';

/** Full history for one person: { PartyID, Patterns: [pattern...] }, oldest first */
export const getPartyWorkingHours = (api, partyID) =>
    webAPICall(api, `/WorkingHours/Party/${partyID}`, null, FEATURE);

/** Team members with a pattern overlapping the range: [{ PartyID, Patterns }] */
export const getTeamWorkingHours = (api, teamID, from, to) =>
    webAPICall(api, `/WorkingHours/Team/${teamID}?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,
        null, FEATURE);

/** Save a pattern starting on effectiveFrom; resolves to the saved pattern */
export const saveWorkingHours = (api, partyID, effectiveFrom, days) =>
    webAPICall(api, '/WorkingHours/Save', { PartyID: partyID, EffectiveFrom: effectiveFrom, Days: days }, FEATURE);

/** Delete a future pattern; resolves to { PartyID, Patterns } after the delete */
export const deleteWorkingHours = (api, workingHoursID) =>
    webAPICall(api, '/WorkingHours/Delete', { WorkingHoursID: workingHoursID }, FEATURE);
